import { Loader } from "@googlemaps/js-api-loader";

export default function Maps() {
	const elements = document.querySelectorAll("[data-map]");
	if (!elements.length) return;

	const loader = new Loader({
		apiKey: process.env.MIX_GOOGLE_MAPS_API,
	});

	Promise.all([
		loader.importLibrary("maps"),
		loader.importLibrary("marker"),
	]).then(([{ Map }, { Marker }]) => {
		elements.forEach((element) => {
			const position = {
				lat: parseFloat(element.dataset.lat),
				lng: parseFloat(element.dataset.lng),
			};

			const map = new Map(element, {
				center: position,
				zoom: parseInt(element.dataset.zoom, 10) || 15,
				disableDefaultUI: true,
				zoomControl: true,
			});

			new Marker({ position, map });
		});
	});
}
